import { Component } from 'react';
import { compose } from 'recompose';
import ContentSpacer from './common/atoms/ContentSpacer';
import ContentOuterBound from './common/atoms/ContentOuterBound';
import * as InternalPropTypes from '../constants/internal-types';
import SideboxMolecule from './common/molecules/Sidebox';
import withImageHelperFactory, {
  WithImageHelperFactoryProps,
} from '../utils/hocs/withImageHelperFactory';
import {
  TypeBackgroundColorTypes,
  TypeFontColorTypes,
  TypeSEOWeightTypes,
} from '../constants/cms-constants';
import SEOWeights from '../constants/cms/control-options/seo-weights';
import { BackgroundColor } from '../stories/blocks/stories/ProfileGrid.stories';

type SideboxProps = {
  headerText?: InternalPropTypes.RichText;
  text?: InternalPropTypes.RichText;
  image?: InternalPropTypes.Image;
  video?: InternalPropTypes.Video;
  factBoxTitleText?: InternalPropTypes.RichText;
  factBoxBodyText?: InternalPropTypes.RichText;
  factBoxFontColor?: TypeFontColorTypes;
  factBoxBackgroundColor?: TypeBackgroundColorTypes;
  backgroundColor?: TypeBackgroundColorTypes;
  seoWeight?: TypeSEOWeightTypes;
};

type SideboxInnerProps = WithImageHelperFactoryProps & SideboxProps;

export class Sidebox extends Component<SideboxInnerProps> {
  static defaultProps = {
    headerText: null,
    text: null,
    image: null,
    video: null,
    factBoxTitleText: null,
    factBoxBodyText: null,
    factBoxFontColor: null,
    factBoxBackgroundColor: null,
    backgroundColor: null,
    seoWeight: SEOWeights.H2,
  };

  render() {
    const {
      headerText,
      text,
      image: asset,
      video,
      factBoxTitleText,
      factBoxBodyText,
      imageHelperFactory,
      factBoxFontColor,
      factBoxBackgroundColor,
      backgroundColor,
      seoWeight,
    } = this.props;

    const imageHelper = imageHelperFactory.createImageHelper(asset);
    const isAnimation = imageHelper?.isAnimation();

    const addStyle = backgroundColor ? { background: backgroundColor } : {};

    let image;
    let animation;

    if (isAnimation) {
      animation = imageHelper.getRawImage() as InternalPropTypes.ImageFile;
    } else if (asset) {
      image = asset;
    }

    return (
      <div css={addStyle}>
        <ContentOuterBound>
          <ContentSpacer>
            <SideboxMolecule
              headerText={headerText}
              text={text}
              image={image}
              video={video}
              animation={animation}
              factBoxTitleText={factBoxTitleText}
              factBoxBodyText={factBoxBodyText}
              factBoxFontColor={factBoxFontColor}
              factBoxBackgroundColor={factBoxBackgroundColor}
              seoWeight={seoWeight}
            />
          </ContentSpacer>
        </ContentOuterBound>
      </div>
    );
  }
}

export default compose<SideboxInnerProps, SideboxProps>(withImageHelperFactory)(
  Sidebox,
);
